import React from 'react';
import { cn } from '../lib/utils';
import VehicleIcon from './VehicleIcon';

const VehicleSelector = ({ vehicles, selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {vehicles.map((vehicle) => {
        const isSelected = selected === vehicle.id;
        
        return (
          <button
            key={vehicle.id}
            type="button"
            onClick={() => onSelect(vehicle.id)}
            className={cn(
              'flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all duration-200 hover:border-[#1db584] hover:bg-green-50 hover:shadow-lg group',
              isSelected
                ? 'border-[#1db584] bg-green-50 shadow-lg ring-2 ring-[#1db584] ring-opacity-20'
                : 'border-gray-200 bg-white hover:scale-105'
            )}
          >
            <div className={cn(
              'mb-3 transition-all duration-200',
              isSelected ? 'scale-110' : 'scale-100 group-hover:scale-110'
            )}>
              <VehicleIcon type={vehicle.id} selected={isSelected} />
            </div>
            <span className={cn(
              'text-xs md:text-sm text-center transition-colors leading-tight font-medium',
              isSelected ? 'text-[#1db584] font-bold' : 'text-gray-700 group-hover:text-[#1db584]'
            )}>
              {vehicle.name}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default VehicleSelector;
